// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".links-list {\n  max-width: 600px;\n  overflow-y: auto;\n  max-height: 300px;\n}\n.links-list .ant-list-header {\n  border: none;\n  padding-bottom: 6px;\n}\n.links-list .ant-list-item {\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 16px;\n  border: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
